import React from 'react';
import dayjs from 'dayjs';
import { SummaryLabelledInfo } from '../labelled-info';
import { FiscalYearLabel } from '../../../fiscal-year/fiscal-year-utils';
import { FiscalYear } from '../../../../../../global/entities/BuyOrder';
import { BuyProcessState } from '../../../../buy-process-form-types';

interface SummaryFiscalYearProps {
  fiscalYear: BuyProcessState['fiscalYear'];
}

type ValidFiscalYear =
  | FiscalYear.JanuaryStart
  | FiscalYear.MayStart
  | FiscalYear.JulyStart
  | FiscalYear.SeptemberStart;

export const SummaryFiscalYear = ({ fiscalYear }: SummaryFiscalYearProps) => {
  const isValidFiscalYear = (
    fiscal?: FiscalYear,
  ): fiscal is ValidFiscalYear => {
    if (!fiscal) return false;

    if (
      fiscal !== FiscalYear.JanuaryStart
      && fiscal !== FiscalYear.MayStart
      && fiscal !== FiscalYear.JulyStart
      && fiscal !== FiscalYear.SeptemberStart
    ) {
      throw new Error(`${fiscal} is an invalid fiscal year.`);
    }

    return true;
  };

  const closingDate = () => {
    const formatted = dayjs(fiscalYear.firstClosingDate).format('YYYY-MM-DD');

    if (fiscalYear.extendedFiscalYear) {
      return `${formatted} (förlängt första räkenskapsår)`;
    }

    return formatted;
  };

  return (
    <React.Fragment>
      {isValidFiscalYear(fiscalYear.fiscalYear) && (
        <SummaryLabelledInfo label="Räkenskapsår">
          {FiscalYearLabel[fiscalYear.fiscalYear]}
        </SummaryLabelledInfo>
      )}

      <SummaryLabelledInfo label="Första bokslutsdatum">
        {closingDate()}
      </SummaryLabelledInfo>
    </React.Fragment>
  );
};
